import { ClassNameMap } from '@mui/material';
import { CSSObject } from 'tss-react';
import { makeStyles } from 'tss-react/mui';

const controlButtonDefaultBackground = '#323232';
const createHover = (color: string): CSSObject => ({
  '&:hover': {
    background: color,
  }
});

export const useVideoStyles = makeStyles<{ classes?: ClassNameMap<'enabledControlButton' | 'disabledControlButton'> }>()((theme) => ({
  controlButton: {
    color: theme.palette.common.white,
    background: controlButtonDefaultBackground,
    ...createHover(controlButtonDefaultBackground),
  },
  disabledControlButton: {
    background: theme.palette.error.main,
    ...createHover(theme.palette.error.main)
  },
  enabledControlButton: {},
  buttonTooltip: {
    fontSize: '14px',
  },
  warningButton: {
    backgroundColor: theme.palette.error.main,
    color: '#FFF',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: 'rgba(137, 36, 17, 1)',
      color: '#FFF',
    }
  },
  screenShareEnabled: {
    background: theme.palette.secondary.main,
    ...createHover(theme.palette.secondary.main)
  },
  screenShareDisabled: {
    background: controlButtonDefaultBackground,
    ...createHover(controlButtonDefaultBackground)
  },
  settingsModalPaper: {
    width: '350px'
  },
  leaveSessionButton: {
    borderRadius: '163px'
  },
  disableToggle: {
    opacity: 0.5,
    cursor: 'default',
  },
}));
